import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const OverContainerSection = styled(Box)`
    display: flex;
    justify-content: center;
    position: relative;
`

export const Section = styled(Box)`
    width: 96%;
    justify-content: space-between;
    align-items: start;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    z-index: 20;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 95%;
        flex-direction: row;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1280px;
        flex-direction: row;
    }
`
export const SectionInformationData = styled(Box)`
    width: 98%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 58%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 58%;
    }
`
export const SectionForm = styled(Box)`
    width: 98%;
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 38%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 30%;
    }
`

export const SectionData = styled(Box)`
    width: 98%;
    display: flex;
    justify-content: start;
    align-items: start;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const TypographySection = styled(Typography)`
    line-height: 36px;
    font-family: inherit;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 46px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const TypographyContent = styled(Typography)`
    line-height: 28px;
    flex-wrap: wrap;
    display: flex;
    white-space: pre-wrap;
    flex-direction: row;
    font-family: inherit;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Content = styled(Box)`
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
